import { Button, Radio } from "@mui/material"
import classes from "./DiscoveryForm.module.css"
import { useState, useEffect } from "react"
import RadioButtonsGroup from "../../Component/UI/RadioGroup/RadioGroup"
import TextInput from "../../Component/UI/TextInput/TextInput"
import { set } from "lodash"
import InputSelectionComponent from "../Dashboard/Component/inputSelection"
import { ENTITY_LABELS, getEntityLabel } from "../../utils/labelMapping"



const SITE_SUGGESTIONS = [
    { id: 1, name: "Reddit", value: "reddit.com" },
    { id: 2, name: "Facebook", value: "facebook.com" },
    { id: 3, name: "Quora", value: "quora.com" },
    { id: 4, name: "X", value: "x.com" },
    { id: 5, name: "LinkedIn", value: "linkedin.com" },
    { id: 6, name: "YouTube", value: "youtube.com" },
    { id: 7, name: "Trust Pilot", value: "trustpilot.com" },
    { id: 8, name: "Glassdoor", value: "glassdoor.com" },
    { id: 9, name: "Wikipedia", value: "wikipedia.org" },
]

const Form = ({ setInputValues, discoveryType, setDiscoveryType, handleClickShow, initialValues = {} }) => {
const RADIO_OPTIONS = [
    { label: ENTITY_LABELS.brand, value: "brand", component: <Radio /> },
    { label: ENTITY_LABELS.product, value: "product", component: <Radio /> },
]
    const [brand, setBrand] = useState(initialValues.brand || "")
    const [category, setCategory] = useState(initialValues.category || "")
    const [persona, setPersona] = useState(initialValues.persona || "")
    const [geography, setGeography] = useState(initialValues.geography || "")
    const [market, setMarket] = useState(initialValues.market || "")
    const [selectedSiteSuggestions, setSelectedSiteSuggestions] = useState(initialValues.siteSuggestions || [])
    const [excludeBrandOwnedSources, setExcludeBrandOwnedSources] = useState(initialValues.excludeBrandOwnedSources || false)

    function handleDiscoveryTypeChange(value) {
        setDiscoveryType(value);
    }

    function handleBrandInputChange(e) {
        setBrand(e.target.value);
    }

    const handleSiteSuggestionsCheckChange = (selected) => {
        const selectedValues = selected?.map((option) => option.value) || [];
        setSelectedSiteSuggestions(selectedValues);
    }

    // Update form fields when initialValues change (for history restoration)
    useEffect(() => {
        if (initialValues.brand !== undefined) setBrand(initialValues.brand || "");
        if (initialValues.category !== undefined) setCategory(initialValues.category || "");
        if (initialValues.persona !== undefined) setPersona(initialValues.persona || "");
        if (initialValues.geography !== undefined) setGeography(initialValues.geography || "");
        if (initialValues.market !== undefined) setMarket(initialValues.market || "");
        if (initialValues.siteSuggestions !== undefined) setSelectedSiteSuggestions(initialValues.siteSuggestions || []);
        if (initialValues.excludeBrandOwnedSources !== undefined) setExcludeBrandOwnedSources(initialValues.excludeBrandOwnedSources || false);
    }, [initialValues]);

    return (
        <>
            <div className={classes.header}>
                <div className={classes.radio}>
                    <RadioButtonsGroup
                        className={classes.type_radio}
                        options={RADIO_OPTIONS}
                        selectedvalue={discoveryType}
                        onChange={handleDiscoveryTypeChange}
                    />
                </div>

            </div>

            <div className={classes.input_group}>

                <div className={classes.input_section}>
                    <div style={{ flex: 1 }}>
                        <TextInput
                            fullWidth
                            value={brand}
                            label={getEntityLabel(discoveryType)}
                            placeholder={
                                discoveryType === "brand" ? ENTITY_LABELS.brandPlaceHolder : ENTITY_LABELS.productPlaceHolder
                            }
                            onChange={handleBrandInputChange}
                        />
                    </div>
                    <div style={{ flex: 1 }}>
                        <TextInput
                            fullWidth
                            value={category}
                            label='Category'
                            placeholder={ENTITY_LABELS.categoryPlaceHolder}
                            onChange={(e) => { setCategory(e.target.value) }}
                        />

                    </div>

                    <div style={{ flex: 1 }}>
                        <TextInput
                            fullWidth
                            value={persona}
                            label='Persona'
                            placeholder={ENTITY_LABELS.personaPlaceHolder}
                            onChange={(e) => { setPersona(e.target.value) }}
                        />

                    </div>

                    <div style={{ flex: 1 }}>
                        <TextInput
                            fullWidth
                            value={geography}
                            label='Geography'
                            placeholder='eg United States'
                            onChange={(e) => { setGeography(e.target.value) }}
                        />

                    </div>
                </div>

                <div className={classes.input_section}>
                    <div style={{ flex: 1 }}>
                        <TextInput
                            fullWidth
                            value={market}
                            label="Market"
                            placeholder='eg California'
                            onChange={(e) => { setMarket(e.target.value) }}
                        />
                    </div>
                    <div style={{ flex: 1, marginTop: '18px' }}>
                        <InputSelectionComponent
                            selectedOptions={selectedSiteSuggestions || []}
                            handleChange={handleSiteSuggestionsCheckChange}
                            options={SITE_SUGGESTIONS}
                            type="site"
                        />

                    </div>
                    <div style={{ flex: 1, marginTop: '18px', display: 'flex', alignItems: 'center' }}>
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="eliminateBrandContentDiscovery"
                                checked={excludeBrandOwnedSources}
                                onChange={(e) => setExcludeBrandOwnedSources(e.target.checked)}
                            />
                            <label className="form-check-label" htmlFor="eliminateBrandContentDiscovery" style={{ marginLeft: '8px', marginBottom: 0 }}>
                                Eliminate brand content/posts
                            </label>
                        </div>

                    </div>
                    <div style={{ flex: 1, marginTop: '18px' }}>

                        <Button

                            style={{
                                backgroundColor: "gainsboro",
                                borderColor: "gainsboro",
                                color: "black",
                                // textTransform: "capitalize",
                            }}
                            variant="contained"
                            color={"secondary"}
                            onClick={() => {
                                handleClickShow({ brand, category, persona, geography, market, siteSuggestions: selectedSiteSuggestions, excludeBrandOwnedSources })
                            }
                            }
                        >
                            Get Conversations Data
                        </Button>

                    </div>

                </div>
            </div>

        </>
    )
}

export default Form